import { Controller } from '@hotwired/stimulus';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export default class extends Controller {
  static targets = [
    'container',
    'pagination',
    'prevButton',
    'nextButton',
    'currentSlide',
    'totalSlides',
  ];

  connect() {
    this.initSwiper();
  }

  initSwiper() {
    if (this.swiper) return;

    this.swiper = new Swiper(this.containerTarget, {
      modules: [Navigation, Pagination],
      slidesPerView: 1,
      spaceBetween: 0,
      centeredSlides: true,
      loop: false,
      updateOnImagesReady: true,
      watchSlidesProgress: true,
      navigation: {
        nextEl: this.hasNextButtonTarget ? this.nextButtonTarget : null,
        prevEl: this.hasPrevButtonTarget ? this.prevButtonTarget : null,
      },
      on: {
        init: this.updatePagination.bind(this),
        slideChange: this.updatePagination.bind(this),
      },
    });

  }

  updatePagination() {
    if (
      this.hasCurrentSlideTarget &&
      this.hasTotalSlidesTarget &&
      this.swiper &&
      typeof this.swiper.activeIndex !== 'undefined'
    ) {
      this.currentSlideTarget.textContent = this.swiper.activeIndex + 1;
      this.totalSlidesTarget.textContent = this.swiper.slides.length;
    }
  }

  disconnect() {
    if (this.swiper) {
      this.swiper.destroy();
      this.swiper = null;
    }
  }
}
